<template>
  <section class="promo__codes-form-wrap">
    <Modal
      v-model:show="active"
      @close="close"
    >
      <template v-slot:header>
        <h5 class="modal-title">
          {{ $t('promoCodes.addPromocodes.title') }}
        </h5>
      </template>

      <div>
        <form @keyup.enter="send">
          <UiInput
            v-model="form.promocode"
            v-model:error="errors.promo_code"
            class="mb-16"
            :label="$t('promoCodes.addPromocodes.promocode')"
            :placeholder="$t('promoCodes.addPromocodes.promocode')"
            error-clear-on-change
          />
          <UiSelect
            v-if="hideSelect(offers)"
            v-model="offer"
            :error="errors.affiliate_offer_id ? errors.affiliate_offer_id[1].message : ''"
            :label="$t('promoCodes.addPromocodes.offer')"
            :placeholder="$t('promoCodes.addPromocodes.selectOffer')"
            :list="offers"
            is-search
            class="mb-16"
          />
          <UiSelect
            v-model="traffic_source_id"
            :label="$t('trafficSources.trafficSource')"
            :placeholder="$t('offerRequest.noTrafficSources')"
            :list="sources"
            class="mb-16"
            is-search
          />
          <div class="row row-wrap__subid">
            <div
              v-for="(item, i) in form.subids"
              :key="i"
              class="mb-12 col-6 col-6__add-subid"
            >
              <UiInputSubid
                v-model="item.value"
                :label="`SubID ${form.subids.indexOf(item) + 1}`"
                :placeholder="$t('trafficSources.postbacks.notSpecified')"
                :can-delete="form.subids.indexOf(item) === form.subids.length - 1 && form.subids.length > 1"
                @delete="popSubIds"
              />
            </div>
            <div class="col-6 !tw-flex !tw-items-end col-6__add-subid">
              <button
                :disabled="form.subids.length >= 5"
                href="#"
                class="btn btn-block btn-outline-primary btn-sm mb-12"
                @click.prevent="form.subids.length < 5 && addSubId()"
              >
                + {{ $t('promoCodes.addPromocodes.addAnotherSubid') }}
              </button>
            </div>
          </div>
        </form>
      </div>

      <template v-slot:footer>
        <div class="!tw-text-right !tw-flex !tw-items-center">
          <a
            class="btn btn-outline-primary btn-sm !tw-flex !tw-items-center !tw-justify-center"
            @click="close"
          >
            {{ $t('promoCodes.addPromocodes.cancel') }}
          </a>
          <a
            class="btn btn-primary btn-sm !tw-flex !tw-items-center !tw-justify-center !tw-ml-1rem pt-0 pb-0"
            @click="send"
          >
            <span v-if="!$store.state.errors.loading">
              {{ $t('promoCodes.addPromocodes.title') }}
            </span>
            <i
              v-if="$store.state.errors.loading"
              class="fas fa-spinner spinner-hide"
            />
          </a>
        </div>
      </template>
    </Modal>
  </section>
</template>

<script>
import { Modal } from '@/components';

export default {
  components: {
    Modal,
  },
  props: ['offsetParams'],
  emits: ['addPromoCode'],
  data() {
    return {
      active: false,
      offer: '',
      changed: false,
      sending: false,
      traffic_source_id: '',
      errors: {},
      form: {
        promocode: '',
        subids: [{ value: '' }],
      },
    };
  },
  computed: {
    offers() {
      return this.$store.state.promocode.offers.map((e) => ({
        text: e.name,
        id: e.id,
      }));
    },
    sources() {
      return this.$store.state.trafficSource.list.map((e) => ({
        id: e.data.id,
        text: e.name,
      }))
        .concat({
          id: '',
          text: this.$t('offerRequest.noTrafficSources'),
        });
    },
  },
  watch: {
    traffic_source_id(id) {
      this.form.subids = [];
      const source = this.$store.state.trafficSource.list.filter((e) => e.data.id === id)[0];
      if (!source) {
        this.form.subids = [{ value: '' }];
        return;
      }

      // Push subids
      Object.keys(source)
        .map((k) => {
          if (k.startsWith('subid')) {
            const subid_index = parseInt(k.replace('subid', '')) - 1;
            if (source[k]) {
              this.form.subids.push({
                value: source[k],
              });
            } else {
              this.form.subids.push({
                value: '',
              });
            }
          }
        });

      // reduce subids
      for (let i = this.form.subids.length - 1; i >= 1; i--) {
        if (!this.form.subids[i].value) {
          this.form.subids.pop();
        } else {
          break;
        }
      }
    },
  },
  activated() {
    this.$store.dispatch('getTrafficSources', {});
    this.$store.dispatch('getPromocodeOffersLazy');
  },
  methods: {
    hideSelect(optoins = []) {
      return optoins.length > 1;
    },

    selectOffer(v) {
      this.offer = v.id;
    },
    open() {
      this.reset();
      this.active = true;
      if (this.offers.length === 1) {
        this.offer = this.offers[0].id;
      }
    },
    close() {
      this.active = false;
      this.traffic_source_id = '';
      this.sending = false;
      this.reset();
    },
    reset() {
      this.errors = {};
      this.changed = false;
      this.form.promocode = '';
      this.offer = '';
      this.form.subids = [
        {
          value: '',
        },
      ];
    },
    send() {
      this.sending = true;
      const data = {
        traffic_source_id: this.traffic_source_id,
        affiliate_offer_id: this.offer,
        promo_code: this.form.promocode,
        status: 'active',
      };

      this.form.subids.forEach((cur, i) => {
        data[`subid${parseInt(i) + 1}`] = cur.value;
      });

      if (data.affiliate_offer_id !== this.$t('promoCodes.addPromocodes.selectOffer')) {
        this.$store
          .dispatch('createPromocode', data)
          .then((res) => {
            this.close();
            this.$emit('addPromoCode');
            this.$store.dispatch('getPromocodesCount', { media_buying_campaign_id: 'null' });
            this.$store.dispatch('getPromocodesLazy', { ...this.offsetParams });
            this.$alert.success(this.$t('promoCodes.alerts.wasCreated'));
          })
          .catch((err) => {
            const { code, message, errors } = err?.response?.data || {};

            if (code === 'AFFILIATE_LIMITS_EXCEEDED_ERROR' && message) {
              this.$alert.error(message);
            }

            this.errors = errors || {};
          });
      }
    },
    addSubId() {
      this.form.subids.push({
        value: '',
      });
    },
    popSubIds(item) {
      this.form.subids.pop();
    },
  },
};
</script>

<style lang="scss">
// vue3-migration -- '@/assets/theme/common-page-styles.scss'
// @import 'src/assets/theme/default/promocodes/addpromocode';
</style>
